import axios from "axios";
import { Message as ElMessage } from 'element-ui'
import * as dayjs from 'dayjs'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.timeout = 60000;
// axios.defaults.withCredentials = true;

//get
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get.Accept = 'application/json';

//post
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const jsonHeader = { 'Content-Type': 'application/json' };

const CancelToken = axios.CancelToken;

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  if (process.env.NODE_ENV !== 'development') {
    if (config.url.includes('/edu')) {
      config.url = config.url.replace('/edu/', '/api/');
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error)
})

//响应拦截器
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error)
})

function request (axiosOpts) {
  return new Promise((resolve, reject) => {
    axios.request(axiosOpts).then(res => {
      if (res?.data !== undefined) {
        resolve(res.data)
      } else {
        resolve(res)
      }
    }).catch(err => {
      if (axiosOpts.handleError ?? true) {
        _handleError(axiosOpts, err)
      }
      reject(err)
    })
  })
}

function _handleError (axiosOpts, err) {
  let msg = err;
  let extendMsgs = [
    `url : ${axiosOpts.url}`,
    `request_time : ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`
  ]
  if (err.errstr) {
    msg = err.errstr;
    extendMsgs.push(`trace_id : ${err.trcid}`);
  }
  ElMessage({ type: 'error', message: msg, extendMsgs: extendMsgs.join('\r\n') })
}

export default {
  get (url, params = {}, responseType, handleError = true) {
    return request({
      url: url,
      method: 'get',
      responseType: responseType,
      params: params,
      handleError: handleError
    })
  },
  post (url, body = {}, params = {}, handleError = true, fn, cancelToken, axiosOpts = true) {
    const formData = new FormData()
    Object.keys(body).forEach((key) => {
      formData.append(key, typeof body[key] === 'object' ? JSON.stringify(body[key]) : body[key])
    })
    let config = {
      url: url,
      method: 'post',
      data: formData,
      params: params,
      headers: axios.defaults.headers.post,
      handleError: handleError,
      onUploadProgress: fn
    }
    if (cancelToken) {
      config.cancelToken = new CancelToken(function executor (c) {
        cancelToken.cancel = c
      })
    }
    return request(config)
  },
  postJson (url, body = {}, params = {}, fn) {
    return request({
      url: url,
      method: 'post',
      data: body,
      params: params,
      headers: jsonHeader,
      onUploadProgress: fn
    })
  }
}